import { render, staticRenderFns } from "./CourseSessionEducators.vue?vue&type=template&id=a0408eaa&scoped=true"
import script from "./CourseSessionEducators.vue?vue&type=script&lang=ts"
export * from "./CourseSessionEducators.vue?vue&type=script&lang=ts"
import style0 from "./CourseSessionEducators.vue?vue&type=style&index=0&id=a0408eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0408eaa",
  null
  
)

export default component.exports